import { render, staticRenderFns } from "./listExpedicao.vue?vue&type=template&id=545b9efe"
import script from "./listExpedicao.ts?vue&type=script&lang=js&external"
export * from "./listExpedicao.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545b9efe')) {
      api.createRecord('545b9efe', component.options)
    } else {
      api.reload('545b9efe', component.options)
    }
    module.hot.accept("./listExpedicao.vue?vue&type=template&id=545b9efe", function () {
      api.rerender('545b9efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/listExpedicao.vue"
export default component.exports